import { TechCheckType } from '@airreading/common/data';
import { Badge } from '@/components/ui/badge';
import { getTechCheckTypeLabel } from '@/lib/coach-utils';

interface TechCheckTypeBadgeListProps {
  techs: TechCheckType[] | undefined;
}

export function TechCheckTypeBadgeList({ techs }: TechCheckTypeBadgeListProps) {
  if (!techs || techs.length === 0) {
    return <span className="text-muted-foreground">None</span>;
  }

  return (
    <div className="flex flex-wrap gap-1">
      {techs.map((tech) => (
        <Badge key={tech} variant="outline">
          {getTechCheckTypeLabel(tech)}
        </Badge>
      ))}
    </div>
  );
}
